import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';
import { TokenService } from '../services/auth/token.service';
import { some } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  private urls: string[];

  constructor(private tokenService: TokenService) {
    // We still need TokenService for URL filtering
    this.tokenService.urlsSubject.subscribe(urls => {
      this.urls = urls;
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('access_token');
    
   
      
   
    request = token ? this.addHeader(request) : request.clone();
    return next.handle(request);
  }

  addHeader(request: HttpRequest<any>) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
      },
    });
  }
}
